<template>
  <div class="tw-relative tw-inline-block tw-w-[100px] tw-h-[100px]">
    <canvas ref="canvas" width="100" height="100"></canvas>
    <div class="tw-absolute tw-top-1/2 tw-left-1/2 tw--translate-x-1/2 tw--translate-y-1/2 tw-text-lg tw-font-bold tw-text-emerald-500">{{ Math.round(percentage) }}%</div>
  </div>
</template>

<script>
import { ref, watch, onMounted, computed } from "vue";
import { useStore } from 'vuex';


export default {
  props: {
    percentage: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const store = useStore();
    const theme = computed(() => store.state.ui.theme);
    const canvas = ref(null);
    
    const drawProgressCircle = () => {
      const ctx = canvas.value.getContext("2d");
      const radius = 40;
      const lineWidth = 10;
      const center = 50;
      const percentage = props.percentage;

      ctx.clearRect(0, 0, 100, 100);

      ctx.beginPath();
      ctx.arc(center, center, radius, 0, 2 * Math.PI);
      ctx.lineWidth = lineWidth - 0.5;
      ctx.strokeStyle = theme.value === 'dark' ? "#475569" : "#E2E8F0";
      ctx.stroke();

      ctx.beginPath();
      ctx.arc(center, center, radius, -0.5 * Math.PI, (percentage / 100) * 2 * Math.PI - 0.5 * Math.PI);
      ctx.lineWidth = lineWidth;
      ctx.strokeStyle = "#10b981";
      ctx.stroke();
    };

    watch(() => [theme.value, props.percentage], drawProgressCircle);

    onMounted(() => {
      drawProgressCircle();
    });

    return {
      canvas
    };
  }
};
</script>
